import { lazy } from "react";
import { paths } from "~/router/paths";
import { app } from "~/helpers/routes";

const AIModelsPhotoshootPage = lazy(() => import("~/pages/ai-models-photoshoot"));

export const routes: Array<any> = [
  {
    path: paths["ai-models-photoshoot"].index,
    element: app(AIModelsPhotoshootPage),
  },
]; 